/*eslint-disable */
import React, { ComponentType, FC, memo } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { areEqualObjects } from 'Utils/lodashUtils';

export default function withMutation(
  WrappedComponent: ComponentType,
  mutationQuery: string
) {
  const Mutation: FC<any> = memo((props: any) => {
    const [update] = useMutation(gql(mutationQuery));
    const mutate = (
      variables: any
    ) => {
      // Send the mutation to the server
      return update({ variables });
    };

    return <WrappedComponent mutate={mutate} {...props} />;
  }, areEqualObjects);

  return Mutation;
}
